import React from "react";
import { Check } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const STEPS = ["pending", "confirmed", "shipped", "delivered"];
const LABEL_KEY = {
  pending: "trackPending",
  confirmed: "trackConfirmed",
  shipped: "trackShipped",
  delivered: "trackDelivered",
};

export const OrderTimeline = ({ status }) => {
  const { t } = useLanguage();

  if (status === "cancelled") {
    return (
      <div
        className="text-xs text-red-400 font-medium inline-flex items-center gap-2"
        data-testid="order-timeline-cancelled"
      >
        <span className="w-2 h-2 rounded-full bg-red-400" />
        {t("trackCancelled")}
      </div>
    );
  }

  const currentIdx = STEPS.indexOf(status) === -1 ? 0 : STEPS.indexOf(status);

  return (
    <div className="flex items-start w-full" data-testid="order-timeline">
      {STEPS.map((step, i) => {
        const done = i <= currentIdx;
        const active = i === currentIdx;
        return (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center gap-1.5 flex-shrink-0 w-14">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                  done ? "bg-[#D4AF37] border-[#D4AF37] text-black" : "border-[#27272A] text-[#9CA3AF]"
                } ${active ? "ring-4 ring-[#D4AF37]/20" : ""}`}
              >
                {done ? <Check size={14} /> : <span className="text-[10px] num-ltr">{i + 1}</span>}
              </div>
              <span
                className={`text-[10px] text-center leading-tight ${
                  done ? "text-[#D4AF37]" : "text-[#9CA3AF]"
                }`}
              >
                {t(LABEL_KEY[step])}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={`flex-1 h-0.5 mt-3.5 transition-all duration-300 ${
                  i < currentIdx ? "bg-[#D4AF37]" : "bg-[#27272A]"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
